/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Calorieconso1Inputs */



/**
* | output |
* | --- |
* | "Calorie consumption" |
*
* @param {Br_History_Key_Calorieconso1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_calorieconso1 = /** @type {((inputs?: Br_History_Key_Calorieconso1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Calorieconso1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Calorie consumption")
	return /** @type {LocalizedString} */ ("Consommation de calories")
});
export { br_history_key_calorieconso1 as "br_history_key_calorieConso" }